import { fetchWrapper } from '../../helpers';

const BASE_URL = `${process.env.REACT_APP_API_URL}/sdk-config/platforms`;

export const getPlatforms = async () => {
    const res = await fetchWrapper.get(BASE_URL);
    return res.data;
};

export const getPlatform = async (platformId) => {
    const res = await fetchWrapper.get(`${BASE_URL}/${platformId}`);
    return res.data;
};

export const createPlatform = async (payload) => {
    const res = await fetchWrapper.post(BASE_URL, payload);
    // fetchWrapper resolves (rather than rejects) with the raw Response on a non-2xx
    // status, so a rejected create (e.g. duplicate name) would otherwise look like success.
    if (res instanceof Response) {
        throw new Error(`Failed to create platform (${res.status})`);
    }
    return res.data;
};

export const updatePlatform = async (platformId, updates) => {
    const res = await fetchWrapper.patch(`${BASE_URL}/${platformId}`, updates);
    return res.data;
};

export const reorderPlatforms = async (order) => {
    const res = await fetchWrapper.patch(`${BASE_URL}/reorder`, { order });
    return res.data;
};

export const updateVariantContent = async (platformId, variantId, content) => {
    const res = await fetchWrapper.patch(`${BASE_URL}/${platformId}/variants/${variantId}`, { content });
    return res.data;
};

/**
 * Upserts a platform's documentation in one call.
 * `docs` is a flat list of { variant_id, content } — see sdkDocsModel.js.
 * `typeId` is the platform's documentation type (1 PUSH / 2 EVENT / 3 STORIES).
 * A single request keeps the editor's one Save button atomic instead of firing
 * one request per variant.
 */
export const updatePlatformDocs = async (platformId, typeId, docs) => {
    const res = await fetchWrapper.patch(`${BASE_URL}/${platformId}/docs`, { type_id: typeId, docs });
    if (res instanceof Response) {
        throw new Error(`Failed to save documentation (${res.status})`);
    }
    return res.data;
};

export const deletePlatform = async (platformId) => {
    const res = await fetchWrapper.delete(`${BASE_URL}/${platformId}`);
    if (res instanceof Response) {
        throw new Error(`Failed to delete platform (${res.status})`);
    }
    return res.data;
};
